export const DEFAULT_PROFILE = {
    name: "Guest",
    description: "",
    avatar_url: "",
    public_key: "",
    social_connections: [],
};
//# sourceMappingURL=const.js.map